var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFireplaceSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4H21M3 8H21M19 4V20M5 4V20M13.7678 19.219C12.7915 20.2604 11.2085 20.2604 10.2322 19.219C9.74408 18.6983 9.5 18.0158 9.5 17.3333C9.5 16.6509 9.74408 15.9684 10.2322 15.4477C10.2322 15.4477 10.4375 16 11.0625 16.3333C11.0625 15.6667 11.2188 14.6667 11.9956 14C12.625 14.6667 13.2785 14.9258 13.7678 15.4477C14.2559 15.9684 14.5 16.6509 14.5 17.3333C14.5 18.0158 14.2559 18.6983 13.7678 19.219Z",
    stroke: "#9393B0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireplaceSvgrepocom);
export default __webpack_public_path__ + "static/media/fireplace_svgrepo.com.0f822546c19bf6c631886734fc0d7e8a.svg";
export { ForwardRef as ReactComponent };